import { useEffect } from "react";
import Lenis from "lenis";
import "@/App.css";
import { Header } from "@/components/Header";
import { Hero } from "@/components/Hero";
import { Calculator } from "@/components/Calculator";
import { ArtRules } from "@/components/ArtRules";
import { Marquee } from "@/components/Marquee";
import { SeoContent } from "@/components/SeoContent";
import { Commercial } from "@/components/Commercial";
import { Faq } from "@/components/Faq";
import { Footer } from "@/components/Footer";
import { AdSlot } from "@/components/AdSlot";
import { FloatingWhatsApp } from "@/components/FloatingWhatsApp";
import { CookieBanner } from "@/components/CookieBanner";
import { PartnerBanner } from "@/components/PartnerBanner";

function App() {
  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      delete window.__lenis;
    };
  }, []);

  return (
    <div className="App bg-white">
      <Header />
      <main>
        <Hero />
        <div className="bg-white py-8">
          <PartnerBanner />
        </div>
        <Calculator />
        <ArtRules />
        <AdSlot id="after-calculator" className="bg-white py-10" />
        <Marquee />
        <SeoContent />
        <Commercial />
        <Faq />
        <AdSlot id="pre-footer" className="bg-white py-10" />
      </main>
      <Footer />
      <FloatingWhatsApp />
      <CookieBanner />
    </div>
  );
}

export default App;
